import { MouseEvent } from 'react';
import { ReactNode } from 'react';
import { css } from '@emotion/css';

import { Color } from 'css/theme';
import CmsImage from 'components/CmsImage';
import { Asset } from 'api/graphql/generated';

import { EMPTY_ELEMENT } from 'common/utils/react';
import { EMPTY_STRING } from 'common/utils/string';

export const linkType = {
  email: 'mailto:',
  phone: 'tel:',
  website: EMPTY_STRING,
} as const;

type LinkTypeKeys = keyof typeof linkType;
type LinkType = typeof linkType[LinkTypeKeys];

interface Props {
  icon: Asset;
  children: ReactNode;
  type: LinkType;
  href?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

const Styles = {
  tagContainer: css`
    display: flex;
    flex-direction: row;
    background-color: ${Color.Lilac50};
    width: fit-content;
    padding: 0.6rem;
    margin-right: 0.5rem;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    margin-top: 0.5rem;
  `,
  icon: css`
    width: 21px;
  `,
  text: css`
    color: ${Color.Gray800};
    margin-left: 0.7rem;
    margin-bottom: 0.2rem;
  `,
  link: css`
    flex-shrink: none;
  `,
};

const Tag: React.FC<Props> = ({ children, icon, type, href, onClick }) => {
  const description = icon?.description || 'icon';
  const url = icon?.url || '';

  const link = `${type}${href ? href : children}`;

  const tagComponent = (
    <div className={Styles.tagContainer}>
      <CmsImage src={url} alt={description} width={21} height={21} className={Styles.icon} />
      <p className={Styles.text}>{children}</p>
    </div>
  );

  if (!children && !icon) {
    return EMPTY_ELEMENT;
  }

  return (
    <a className={Styles.link} href={link} onClick={onClick}>
      {tagComponent}
    </a>
  );
};

export default Tag;
